import React from 'react';
import styles from './BudgetSection.module.css';

interface BudgetSectionProps {
  title: string;
  amount: number;
  description: string;
}

const BudgetSection: React.FC<BudgetSectionProps> = ({ title, amount, description }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className={styles.section}>
      <h2>{title}</h2>
      <p className={styles.amount}>{formatCurrency(amount)}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export default BudgetSection; 